import {defaultParamsFilter} from './state'

/**
 * Agregar company id
 *
 */
export function setInfoGraphics(state,data) {
    state.dataGraphics = data.graph_1
    state.total_pay = data.graph_1[0]['total_pay']
    state.dataGraphics_2 = data.graph_2
    state.dataGraphics_3 = data.graph_3.dataByMonth
    state.dataGraphics_4 = data.graph_3.dataByYear
    state.dataGraphics_5 = data.graph_5
    state.totales = data.totales
}

/**
 * Cambiar el estado para mostrar gráficas.
 *
 */
export function changeShowGraphics(state, show) {
    state.showGraphics = show
}


/**
 * Cambiar el estado pantalla completa.
 *
 */
export function changeFullScreen(state, isFullscreen) {
    state.fullscreenActive = isFullscreen;
}

/**
 * Cambiar el estado de la pantalla de gráficas.
 *
 * @param {Object} state
 * @param {String} screen
 * @returns {void}
 */
export function changeGraphicScreen(state, screen) {
    state.graphicScreenActive = screen;
}


/**
 * Setear la data de los cancerígenos.
 *
 * @param {Object} state
 * @param {Object} data
 * @returns {void}
 */
export function setCancerogenicData(state, data) {
    state.dataCancerogenic = data;
}


/**
 * Resetear los datos de los cancerígenos.
 *
 * @param {Object} state
 * @returns {void}
 */
export function resetCancerogenicData(state) {
    state.dataCancerogenic = state.defaultCancerogenicData
}

/**
 * Resetear los datos de las gráficas.
 *
 * @param {Object} state
 * @returns {void}
 */
export function resetGraphicsData(state) {
    state.dataGraphics = [];
    state.dataGraphics_2 = [];
    state.dataGraphics_3 = [];
    state.dataGraphics_4 = [];
    state.dataGraphics_5 = [];
    state.total_pay = 0;
    state.totales = {
        totalTanks: 0,
        mercDanger: 0,
        pqNotDangers: 0,
    };
}

/**
 * Establecer a su estado inicial los datos de los productos.
 *
 * @param Object state
 * @returns void
 */
export function setInitialStateProducts(state) {
    state.detailsProducts = defaultParamsFilter()
}

/**
 * Establecer los datos de los productos.
 *
 * @param Object state
 * @param Object { items, data }
 * @returns void
 */
export function setProducts(state, { items, data }) {
    state.detailsProducts = { ...state.detailsProducts, items, data }
}

/**
 * Mutación que establece la página actual.
 *
 * @param Object state
 * @param Integer page
 * @return void
 */
export function setChangePagePagination(state, page) {
    state.detailsProducts.page = page;
}

/**
 * Mutación que establece la cantidad de items por página.
 *
 * @param Object state
 * @param Integer perPage
 * @return void
 */
export function setChangeSizePagination(state, perPage) {
    state.detailsProducts.per_page = perPage;
}

/**
 * Mutación que establece la información para la gráfica de Toxicidad Acumulada - Por mes en rango de año.
 *
 * @param Object state
 * @param Object nextState
 * @return void
 */
export function setAccumulatedToxicityGraph(state, nextState) {
    state.accumulatedToxicityGraph = nextState;
}

/**
 * Mutación que establece la información de detalles de los productos de la gráfica de Toxicidad Acumulada - Por mes en rango de año.
 *
 * @param Object state
 * @param Object nextState
 * @return void
 */
export function setAccumulatedProductDetails(state, nextState) {
    state.accumulatedProductDetails = nextState;
}

/**
 * Mutación que establece si se ve o no la información de detalles de los productos de la gráfica de Toxicidad Acumulada - Por mes en rango de año.
 *
 * @param Object state
 * @param Object nextState
 * @return void
 */
export function setAccumulatedShowProductsDetails(state, nextState) {
    state.accumulatedShowProductsDetails = nextState;
}

/**
 * Mutación que establece la información para la gráfica de Toxicidad aguda.
 *
 * @param Object state
 * @param Object nextState
 * @return void
 */
export function setAcuteToxicity(state, nextState) {
    state.acuteToxicity = nextState;
}

/**
 * Mutación que establece la información de los detalles de para la gráfica de Toxicidad aguda.
 *
 * @param Object state
 * @param Object nextState
 * @return void
 */
export function setAcuteToxicityProductDetails(state, nextState) {
    state.acuteToxicityProductDetails = nextState;
}

/**
 * Mutación que establece si se muestra o no la información de los detalles de para la gráfica de Toxicidad aguda.
 *
 * @param Object state
 * @param Object nextState
 * @return void
 */
export function setAcuteToxicityShowProductsDetails(state, nextState) {
    state.acuteToxicityShowProductsDetails = nextState;
}

/**
 * Mutación que establece se se esta cargando la información de los detalles de para la gráfica de Toxicidad aguda.
 *
 * @param Object state
 * @param Object nextState
 * @return void
 */
export function setAcuteToxicityLoadingShowProductsDetails(state, nextState) {
    state.acuteToxicityLoadingShowProductsDetails = nextState;
}

/**
 * Mutación que establece los grupos que se están consultando en cancerigenos.
 *
 * @param Object state
 * @param Object filterGroups
 * @return void
 */
export function setFilterGroups(state, filterGroups) {
    state.filterGroups = filterGroups;
}
